import { render } from "./EditDataPriceDialog.vue?vue&type=template&id=154ec75a&ts=true"
import script from "./EditDataPriceDialog.vue?vue&type=script&lang=ts"
export * from "./EditDataPriceDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__